import { NavMeshHelper } from '@spazious/dollhouse-engine';
import { useStore } from '@spazious/dollhouse-store';
import { useStyleVars } from '@spazious/dollhouse-uikit';

export const NavMesh: React.FC = () => {
  const [navMeshColor] = useStyleVars('--spz-sys-color-success');
  const navMesh = useStore(({ world }) => world?.navMesh);
  const showNavMesh = useStore(({ showNavMesh }) => showNavMesh);

  return showNavMesh && navMesh ? <NavMeshHelper color={navMeshColor} navMesh={navMesh} /> : null;
};
